// extracted by mini-css-extract-plugin
module.exports = {"heading":"PageHeader_heading__1jjI1","headingImage":"PageHeader_headingImage__1e8D2"};